import { MutationHookOptions, useMutation } from '@apollo/client';
import { RESEND_INVITE } from '../../graphql/mutations/user';

export const useResendInvite = (
  options?: MutationHookOptions,
) => useMutation(RESEND_INVITE, options);
